import { createFileRoute } from '@tanstack/react-router';

import { CourseCreate } from '@/module/Author/Course/CourseCreate';

export const Route = createFileRoute('/_auth/author/_author/course/_course/create')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.create' },
  },
});

function RouteComponent() {
  return <CourseCreate />;
}
